import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuildYourCommunityPartTwoOverlayComponent } from './build-your-community-part-two-overlay.component';
import { GCAPListModule } from '@lists/_index';

@NgModule({
  imports: [CommonModule, GCAPListModule, BuildYourCommunityPartTwoOverlayComponent],
  exports: [BuildYourCommunityPartTwoOverlayComponent],
})
export class BuildYourCommunityPartTwoOverlayModule {}
